import type { ReactNode } from 'react';
import { cn } from '@/shared/lib/cn';

export type KeyValueRow = {
  key: string;
  label: ReactNode;
  value: ReactNode;
  valueClassName?: string;
};

type KeyValueListProps = {
  rows: readonly KeyValueRow[];
  labelClassName?: string;
  className?: string;
};

/** The design's `.kv` definition list: label column, value column, a line between rows. */
export function KeyValueList({ rows, labelClassName, className }: KeyValueListProps) {
  return (
    <dl className={cn('flex flex-col', className)}>
      {rows.map((row) => (
        <div
          key={row.key}
          className="grid min-h-12 grid-cols-1 items-center gap-1.5 border-line py-1.5 not-first:border-t shell:grid-cols-[minmax(120px,170px)_minmax(0,1fr)] shell:gap-4"
        >
          <dt className={labelClassName}>{row.label}</dt>
          <dd className={row.valueClassName}>{row.value}</dd>
        </div>
      ))}
    </dl>
  );
}
